export class UserData {
    email: string
    firstName: string
    lastName: string
    phone: string
}



// WEBPACK FOOTER //
// ./src/types/UserData.ts